module.exports = __webpack_public_path__ + "img/1241516198.dde6bc39.jpg";